module.exports = __webpack_public_path__ + "img/1d29a95.svg";